<script>

//import NotificationPopover from './NotificationPopover.vue'

export default {
  /*components: {
    NotificationPopover
  },*/

  data: () => {
    return {
      dotMenuImage: require('@/assets/dot-menu.png'),
      inicioImage: require('@/assets/inicio.png'),
      logoutImage: require('@/assets/logout.png'),
      bellImage: require('@/assets/bell.png'),
      usrdata: '',
      isPopoverVisible: false
    }
  },
  methods: {
    togglePopover() {
      this.$emit('close');
      this.isPopoverVisible = !this.isPopoverVisible;
    },
    async getUserData() {
      try {
        let res = await this.$api.get("/auth/users/me");
        if (res.status.toString() === "200") {
          this.usrdata = res.data
          this.$store.commit('updateThisUserData', this.usrdata)
        }
      } catch (error) {
        console.log("can't get user data")
      }
    },
    async logout() {
      try {
        await this.$api.post('/auth/logout', {});
      } catch (error) {
        console.error('Error logging out:', error);
      } finally {
        this.$router.push("/");
      }
    },
    navClose(navigate) {
      this.$emit('close');
      navigate();
    }
  },
  created() {
    this.getUserData()
  }
}

</script>

<template>
  <div class="navbar">
    <div class="menu">
      <button v-on:click="isPopoverVisible = false" @click="$emit('togglenav')" role="link"><img class="logout-icon"
                                                                                                 :src="dotMenuImage">
      </button>
      <router-link to="/scene" custom v-slot="{ navigate }">
        <button v-on:click="isPopoverVisible = false" @click="() => navClose(navigate)" role="link"><img
            class="logout-icon" :src="inicioImage"></button>
      </router-link>
      <router-link to="/scene" custom v-slot="{ navigate }">
        <button v-on:click="isPopoverVisible = false" @click="() => navClose(navigate)" role="link">
          <a>{{ usrdata.firstname }} {{ usrdata.lastname }}</a></button>
      </router-link>

    </div>
    <div class="middle-icons">
      <a style="color: #f9f9f9; font-weight: bold ">ADMIA - SDE</a>
    </div>
    <div class="left-icons">
      <!--<div class="notifications" style="position: relative">
        <button @click="togglePopover" role="link"><img class="logout-icon" :src="bellImage"></button>
        <NotificationPopover v-show="isPopoverVisible" @notification-click="togglePopover"/>
      </div> -->
      <div class="logout">
        <button @click="logout" role="link"><img class="logout-icon" :src="logoutImage"></button>
      </div>
    </div>

  </div>

  <div class="overlay-popover" v-if="isPopoverVisible" @click.stop="isPopoverVisible = false"></div>

</template>

<style scoped>
.overlay-popover {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.navbar {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: 3;
  height: 48px;
  line-height: 48px;

  align-items: center;

  background: var(--gobBlue);
  display: flex;
  padding-left: 3px;
}

.navbar button {
  border: 1px solid var(--gobBlue);
  margin: 3px;
  width: auto;
  height: 30px;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
}

.navbar a {
  color: #ffffff;
  padding-left: 5px;
  font-size: 17px;
}

.left-icons {
  position: absolute;
  right: -0%;
  padding-right: 30px;
  display: flex;
}

.logout-icon {
  padding-top: 12px;
  height: 20px;
}

.middle-icons {
  position: fixed;
  left: 47%;
  display: inline-block;
}

@media (max-width: 600px) {
  .navbar {
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    height: auto;
  }

  .menu, .left-icons {
    grid-column: 1;
    justify-self: left;
  }

  .middle-icons {
    display: none;
  }

  .left-icons {
    justify-self: right;
  }

}
</style>